import { AuthProvider } from '@sdk/authentication/AuthContext';

import EnableIcalModal from '@web/shifts/EnableIcalModal/EnableIcalModal';

const EnableIcalModalAngular = ({ currentUser, opened, onClose, locations }) => {
  return (
    <AuthProvider currentUser={currentUser}>
      <EnableIcalModal
        opened={opened}
        onClose={onClose}
        currentUser={currentUser}
        locations={locations}
      />
    </AuthProvider>
  );
};

export default {
  ReactComponent: EnableIcalModalAngular,
  bindings: {
    opened: '<',
    locations: '<',
    onClose: '&',
    currentUser: '<',
  },
};
